import filter from 'lodash/filter'
import isEqual from 'lodash/isEqual';
import uniq from 'lodash/uniq';
import orderBy from 'lodash/orderBy';
import uniqBy from 'lodash/uniqBy';

import {connect} from '~/redux/connect';

import {
    presentAllMessages, presentAllErrors
} from "~/stateGetter";
import {modelActionsCreator} from "~/actions/model_actions";
import getConfig from "~/config";
import MessageList from "~/ui/components/MessageList/MessageList";


const areStatePropsEqual = (props, prevProps) => {
    return isEqual(props, prevProps);
};

const RXMessageList = connect(
    (state, {modelId, messageSources = []}) => {
        return {
            messages: presentAllMessages(state, modelId, uniq([...messageSources, ...getConfig().messageSources])),
            errors: presentAllErrors(state, modelId, getConfig().errorSources),
        }
    },
    (dispatch, {modelId}) => {
        let { hideMessages } = modelActionsCreator(modelId);

        return {
            hideMessages: () => dispatch(hideMessages()),
        };
    },

    ({ messages, errors, ...otherProps }, dispatcher, {filterMessages, messageSources, excludeMessageTags, scope = 'local', ...otherOwnProps}) => {
        let filterTheMessages = (messages) => {
            excludeMessageTags = excludeMessageTags ?? getConfig().excludeMessageTags ?? [];

            messages = filter(messages, (message) => {
                if (!message?.message?.length) return false;

                const tags = message.tags ?? [];
                const skip = excludeMessageTags.some((tagsToExclude) => {
                    if (!Array.isArray(tagsToExclude)) return tags.includes(excludeTag);
                    return tagsToExclude.every((excludeTag) => tags.includes(excludeTag))
                });

                if (skip) return false;
                return message.scope === 'local' || message.scope === scope
            });

            messages = uniqBy(messages, 'message');
            messages = filterMessages ? filterMessages(messages) : messages;

            // Last message should is displayed above.
            return messages
                .sort((a, b) => a.created_at - b.created_at)
                .reverse()
                .map((message) => ({
                    ...message,
                    type: message.status || message.type,
                }));
        };

        messages = filterTheMessages([
            ...messages,
            ...errors
        ])

        return {
            ...otherProps,
            ...otherOwnProps,
            ...dispatcher,
            messages: orderBy(messages,'status'),
            lastMessageCreatedAt: messages.length > 0 ? Math.max(...messages.map(m => m.created_at ? new Date(m.created_at).getTime() : 0)) : null,
        }
    }, { areStatePropsEqual }
)(MessageList);

export default RXMessageList;